const defaultConfig = {
  showHelpForm: true,
  showAcknowledgementOfCountry: true,
  showThreeColLinks: false,
  showFooterLinks: true,
  showFlags: true,
  helpNumber: '13 77 88',
  helpForm: '/helpForm',
};

export default defaultConfig;
